// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2bIn3","buttons":"Footer_buttons__3aI7G"};